import * as styles from './Text.css';
import { PropsWithChildren } from 'react';

const Text = ({ children }: PropsWithChildren) => {
  return <p className={styles.container}>{children}</p>;
};

export default Text;
